import { render, staticRenderFns } from "./ProductIngredientsDetails.vue?vue&type=template&id=5b777e2b&scoped=true&lang=pug&"
import script from "./ProductIngredientsDetails.vue?vue&type=script&lang=js&"
export * from "./ProductIngredientsDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProductIngredientsDetails.vue?vue&type=style&index=0&id=5b777e2b&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b777e2b",
  null
  
)

export default component.exports